<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-modal id="visualizar-modal" v-model="showModal"> </b-modal>

                <b-form-row @keyup.enter="load">
                    <b-col lg="2" sm="12" class="text-left">
                        <lg-form-const-select label="Situação:" v-model="form.situacao"
                            :options="form.optionsFilterSituacao" @change="load" />
                    </b-col>
                    <b-col lg="8" sm="10" class="text-left">
                        <lg-form-input v-model="form.descricao" label="Descrição:" description=" " />
                    </b-col>
                    <b-col cols="2" class="text-right mt-2">
                        <b-button id="btnPesquisar" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load">
                            <b-tooltip :target="'btnPesquisar'" title="Localizar"></b-tooltip>
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-card>

            <b-card bg-variant="light">
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :filter="filtro" :hover="true"
                    @row-dblclicked="unidadeAdministrativaSelect" show-empty>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template #empty>
                        <p>
                            Nenhum Registro encontrado
                        </p>
                    </template>


                    <template v-slot:cell(pertenceAlmoxarifado)="row">
                        <b-button v-if="row.item.pertenceAlmoxarifado" :id="row.index + 'pertenceAlmoxarifado'"
                            class="my-2" size="sm" pill variant="primary">
                            <b-icon icon="check" />

                            <b-tooltip :target="row.index + 'pertenceAlmoxarifado'" title="Almoxarifado"></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(pertencePatrimonio)="row">
                        <b-button v-if="row.item.pertencePatrimonio" :id="row.index + 'pertencePatrimonio'" class="my-2"
                            size="sm" pill variant="primary">
                            <b-icon icon="check" />

                            <b-tooltip :target="row.index + 'pertencePatrimonio'" title="Patrimonio"></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(configAlmoxarifado)="row">
                        <b-button :disabled="!temPrivilegioConfiguracaoAlmoxarifadoAcesso()"
                            :id="row.index + 'configAlmoxarifado'" class="my-2" size="sm" pill variant="primary"
                            @click="abrirModalConfiguracaoAlmoxarifado(row.item)">
                            <b-icon icon="calendar2-minus" />
                            <b-tooltip :target="row.index + 'configAlmoxarifado'"
                                title="Configuração Almoxarifado"></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(configLocalizacao)="row">
                        <b-button :disabled="!temPrivilegioDepartamentoLocalArmazenamentoAcesso()"
                            :id="row.index + 'configLocalizacao'" class="my-2" size="sm" pill variant="primary"
                            @click="abrirModalConfiguracaoLocalizacao(row.item)">
                            <b-icon icon="pin-map" />
                            <b-tooltip :target="row.index + 'configLocalizacao'"
                                title="Configuração Localização"></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(situacao)="row">
                        <div :id="row.index + 'switch'">
                            <b-form-checkbox v-model="row.item.situacao" name="check-button" switch size="lg" :value="1"
                                :unchecked-value="0" :disabled="!temPrivilegioEdicao()" />
                            <b-tooltip :target="row.index + 'switch'" title="Ativo/Inativo..."></b-tooltip>
                        </div>
                    </template>

                    <template v-slot:cell(action)="row">
                        <b-button :id="row.index + 'novo-button'" class="my-2" size="sm" pill variant="primary"
                            @click="addChefe(row.item)">
                            <b-icon icon="person" />
                            <b-tooltip :target="row.index + 'novo-button'" title="Adicionar chefe..."></b-tooltip>
                        </b-button>

                    </template>
                </b-table>

                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <ConfiguracaoAlmoxarifadoUnidadeAdministrativa v-if="showConfiguracaoAlmoxarifado"
            @close="fecharModalConfiguracaoAlmoxarifado" :departamento="departamento" :prefix="prefix + title + ' > '">
        </ConfiguracaoAlmoxarifadoUnidadeAdministrativa>

        <ConfiguracaoUnidadeAdministrativaLocalArmazenamento v-if="showConfiguracaoALocalizacao"
            @close="fecharModalConfiguracaoLocalizacao" :departamento="departamento" :prefix="prefix + title + ' > '">
        </ConfiguracaoUnidadeAdministrativaLocalArmazenamento>

        <Lg-finder-page-pessoa-modal v-if="mostrarFinder" @onSelect="handleResponsavel" ref="finderPessoaUnidadeChefe"
            :prefix="prefix + title + ' > '"></Lg-finder-page-pessoa-modal>

    </b-card>
</template>

<script>
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import DepartamentoService from "@/core/api/DepartamentoService"
import ConfirmMixin from "@/core/mixins/confirm"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import ConfiguracaoAlmoxarifadoUnidadeAdministrativa from "./ConfiguracaoAlmoxarifadoUnidadeAdministrativa.vue"
import ConfiguracaoUnidadeAdministrativaLocalArmazenamento from "./ConfiguracaoUnidadeAdministrativaLocalArmazenamento.vue"
import LgFinderPagePessoaModal from "@/components/Modal/LgFinderPagePessoaModal.vue";
import ResourceService from "@/core/api/ResourceService";

export default {
    name: "UnidadeAdministrativaList",

    components: {
        LgFormInput,
        LgFormConstSelect,
        ConfiguracaoAlmoxarifadoUnidadeAdministrativa,
        ConfiguracaoUnidadeAdministrativaLocalArmazenamento,
        LgFinderPagePessoaModal
    },

    props: {
        onDblClickUnidadeAdministrativa: Function,
        prefix: { type: String, default: "" },
        title: {
            type: String,
            default: "Unidade Administrativa",
        },
    },

    data() {
        return {
            mostrarFinder: false,
            showConfiguracaoAlmoxarifado: false,
            showConfiguracaoALocalizacao: false,
            departamento: {},
            params: {},
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            showModal: false,
            records: [],
            form: {
                descricao: "",
                situacao: 1,
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: null },
                    { key: "filterSituacao", text: "Ativo", value: 1 },
                    { key: "filterSituacao", text: "Inativo", value: 0 },
                ],
            },
        }
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService('/api/departamentos');
        this.$DepartamentoService = new DepartamentoService()
    },

    mounted() {
        this.load()
    },

    watch: {
        page() {
            this.load()
        },
    },
    computed: {
        tableFields() {
            return [
                {
                    key: "sigla",
                    label: "Sigla",
                    thStyle: "font-size: 10px; font-weight: 400;",
                    tdStyle: "font-size: 10px",
                },
                {
                    key: "descricao",
                    label: "Unidades Administrativas",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "pessoaChefe",
                    label: "Chefe Unidade",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "pertenceAlmoxarifado",
                    label: "A",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "pertencePatrimonio",
                    label: "P",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "configAlmoxarifado",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "configLocalizacao",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "situacao",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "action",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
            ]
        },
    },

    methods: {
        async handleResponsavel(pessoa) {
            this.mostrarFinder = false;


            let response = await this.$confirm(
                "Deseja mudar o responsável pelos patrimônios da unidade administrativa para " + pessoa.nome + "?",
                ""
            );

            await this.$service.put(`${this.itemSelecionado.id}/${pessoa.id}/${response?1:0}`);

            this.$notify({
                type: "success",
                message: "Chefe associado com sucesso",
            });

            this.load();

        },
        async addChefe(item) {
            this.itemSelecionado = item;
            this.mostrarFinder = true;
            this.$nextTick(() => {
                this.$refs.finderPessoaUnidadeChefe.show();
            });

        },
        temPrivilegioConfiguracaoAlmoxarifadoAcesso() {
            return verificaPrivilegio(PrivilegiosEnum.CONFIGURACAO_ALMOXARIFADO_ACESSAR);

        },
        temPrivilegioDepartamentoLocalArmazenamentoAcesso() {
            return verificaPrivilegio(PrivilegiosEnum.DEPARTAMENTO_LOCAL_ARMAZENAMENTO_ACESSAR);

        },
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);

        },
        async load() {
            this.busy = true
            await this.$DepartamentoService
                .findAll({
                    size: this.perPage,
                    page: this.page,
                    descricao: this.form.descricao,
                    situacao: this.form.situacao,
                })
                .then(response => {
                    this.records = response.data.content
                    this.total = response.data.totalElements
                    this.totalPage = response.data.totalPages
                    this.busy = false
                })
                .finally(() => {
                    this.busy = false
                })
        },
        fecharModalConfiguracaoAlmoxarifado() {
            this.departamento = {};
            this.showConfiguracaoAlmoxarifado = false;
            this.load();

        },
        abrirModalConfiguracaoAlmoxarifado(item) {
            this.departamento = item;
            this.showConfiguracaoAlmoxarifado = true;
        },
        fecharModalConfiguracaoLocalizacao() {
            this.departamento = {};
            this.showConfiguracaoALocalizacao = false;
            this.load();

        },
        abrirModalConfiguracaoLocalizacao(item) {
            this.departamento = item;
            this.showConfiguracaoALocalizacao = true;
        },

        clearForm() {
            this.form.descricao = ""
            this.form.situacao = "1"
            this.load()
        },

        async visualizarResource() {
            this.showModal = true
        },

        async unidadeAdministrativaSelect(item) {
            this.$emit("onDblClickUnidadeAdministrativa", item)
        },
    },
}
</script>
